<footer class="page-footer" [mmTestId]="'BUYER_PAGES.FOOTER'" *ngIf="loadFooter">
  <div class="page-footer__general">
    <div class="container" fxLayout="row wrap" fxLayoutAlign="space-between">
      <app-footer-navigation
        [isTier3]="isTier3$ | async"
        [isSubsidiaryAccount]="isSubsidiaryAccount$ | async"
        [isMMCompanion]="isMMCompanion"
        fxFlex="100%"
      >
      </app-footer-navigation>
    </div>
  </div>
  <div
    *ngIf="!!marketVatNo"
    class="page-footer__vat"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.mm-mobile="center start"
  >
    <div
      class="page-footer__vat__content"
      fxLayoutAlign="flex-start center"
      fxFlex.mm-mobile="100%"
      fxLayout="row wrap"
    >
      <span>
        &copy; {{ 'FOOTER.ALL_PAGES.COPYRIGHT.LABEL' | translate }} -
        {{ 'FOOTER.ALL_PAGES.VAT_NUMBER.LABEL' | translate }}
        {{ marketVatNo }}
      </span>
    </div>
  </div>
  <div
    class="page-footer__additional"
    id="global-footer"
    fxFlex="1 1 100%"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.mm-mobile="center start"
  >
    <div
      fxFlexOrder="1"
      fxFlexOrder.mm-mobile="2"
      fxLayout="row wrap"
      fxLayoutAlign="flex-start center"
      class="page-footer__additional__content"
    >
      <div
        class="page-footer__legal"
        fxFlex.mm-mobile="100%"
        fxLayout="row wrap"
        fxLayoutAlign.mm-mobile="center center"
      >
        <ng-container *ngFor="let link of legalLinks; let last = last">
          <a
            *ngIf="!(link.hideOnSubsidiary && (isSubsidiaryAccount$ | async))"
            [href]="link.link"
            [mmTestTarget]="'footer-legal-link'"
            [ngClass]="{ 'footer-link--separator': !last }"
            (click)="handleGlobalFooterClickTracking(link.trackingLabel)"
            class="footer-link footer-link--small"
          >
            {{ link.title | translate }}
          </a>
        </ng-container>
        <ng-container
          *ngIf="(accessibilityLink.title | translate) !== accessibilityLink.title &&
            (accessibilityLink.link | translate) !== accessibilityLink.link
          "
        >
          <a
            *ngIf="!(accessibilityLink.hideOnSubsidiary && (isSubsidiaryAccount$ | async))"
            [href]="accessibilityLink.link | translate"
            [mmTestTarget]="'footer-legal-link'"
            [ngClass]="{ 'footer-link--separator': !last }"
            (click)="handleGlobalFooterClickTracking(accessibilityLink.trackingLabel)"
            class="footer-link footer-link--small"
          >
            {{ accessibilityLink.title | translate }}
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</footer>
